window.addEventListener("load", function() {

    console.log('cookieconsent initialise');
    window.cookieconsent.initialise({
        "palette": {
            "popup": {
                "background": "#252e39"
            },
            "button": {
                "background": "#14a7d0"
            }
        },
        "theme": "classic",
        "content": {
            "message": "En poursuivant votre navigation sur ce site, vous acceptez l’utilisation de cookies susceptibles de réaliser des statistiques de visites ou de permettre de vous proposer des services, offres ou publicités, y compris de partenaires tiers adaptés à vos centres d’intérêt.",
            "dismiss": "<i class='fas fa-check' aria-hidden='true'></i> OK, tout accepter",
            "link": "Personnaliser",
            "href": "#"
        }
    });

    $('.cc-link').removeAttr('target');

    $('.cc-link').click(function() {
        initModalType('#elixis-game-large-modal', 'cookies');
        initModalTitle('#elixis-game-large-modal', 'Gestion des cookies');
        initModalFooter('#elixis-game-large-modal', '');

        var modalContent = $('#cookiesTmpl').render();

        $('.modal-body', '#elixis-game-large-modal').fadeIn(1000).html(modalContent);
        $('#elixis-game-large-modal').modal();
    });

});
